import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, catchError, map, of } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private tokenKey = 'authToken';
    private guardiaoKey = 'guardiaoKey';
    private apiUrl = `${environment.API_URL}/auth` ;  

    constructor(
        private http: HttpClient
    ){}

    public set token(token: string | null) {
        if (token)
            sessionStorage.setItem(this.tokenKey, token)
    }

    public get token(): string | null {
        return sessionStorage.getItem(this.tokenKey)
    }

    public set guardiao(guardiao: any | null) {
      if (guardiao) {
          sessionStorage.setItem(this.guardiaoKey, JSON.stringify(guardiao));
      } else {
          sessionStorage.removeItem(this.guardiaoKey);
      }
  }
  
  public get guardiao(): any | null {
      const guardiao = sessionStorage.getItem(this.guardiaoKey);
      try { return guardiao ? JSON.parse(guardiao) : null; } catch { return null; }
  }
  
  

    public get identity(): string | null { return sessionStorage.getItem('sgprevIdentity'); }
    public set identity(value: string | null) {
        if (value) sessionStorage.setItem('sgprevIdentity', value);
        else sessionStorage.removeItem('sgprevIdentity');
    }

    public clearToken() {
        this.identity = null;
        sessionStorage.removeItem(this.tokenKey);
        sessionStorage.removeItem(this.guardiaoKey);
    }

    public validateToken(): Observable<boolean> {
        if (!this.token) {
          return of(false);
        }
        const validateTokenUrl =  `${this.apiUrl}/token/validate`;
    
        return this.http.get<boolean>(`${validateTokenUrl}?token=${this.token}`)
          .pipe(
            map(response => !!response),
            catchError(error => {
              console.error('Token validation failed', error);
              return of(false);
            })
          );
      }
}